import { CREATEORUPDATEHOLIDAY_SUCCESS, CREATEORUPDATEHOLIDAY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const createOrUpdateHolidayReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEORUPDATEHOLIDAY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATEORUPDATEHOLIDAY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createOrUpdateHolidayReducer;
